/**
 * Contains enums used for API request and response payloads.
 */

export enum StatusForCompanyEnum {
  Blocked = 'blocked',
  CompanyPositionTemplateBlock = 'company_position_template_block',
  Favorite = 'favorite',
}
